import React, { useRef, useState } from 'react'
import { fieldsTypes } from "./constants"
import SinglelineText from "./Fields/SinglelineText"
import Number from "./Fields/Number"
import MultilineText from "./Fields/MultilineText"
import Group from "./Fields/Group"
import ValidationMessage from '../ValidationMessage/ValidationMessage'
import Button from '../Button/Button'
import { Paragraph } from '../Typography/Paragraph/Paragraph'
import Icon from '../Icon2'
import Dropdown from '../DropDown/Dropdown'
import Tooltip from '../Tooltip/Tooltip'
import cbModal, { ModalBody, ModalFooter, ModalHeader } from '../Modal/Modal'
import ButtonGroup from '../Button/ButtonGroup'
import FieldLabel from '../FieldLabel/FieldLabel'
import InstructionText from '../InstructionText/InstructionText'
import { isEnterPressed } from '../../utils/keyboardUtils'
import Popover from '../Popover/Popover'
import Tags from './Fields/Tag'
import isUndefined from 'lodash/isUndefined'
import PermanentUrl from './Fields/PermanentUrl'
import SelectField from './Fields/SelectField'
import RadioField from './Fields/RadioField'
import CheckboxField from './Fields/CheckboxField'
import SelectSelectedCount from './Fields/SelectSelectedCount'
import Field from '../Field/Field'

const addFormFieldUid = (field, keyName) => {
  field.formFieldUid = `${keyName ? (keyName + '.') : ''}` + field.uid
}

export const fieldMapper = (field, boundaryRef, fieldWidth, keyName, mode, inGroupPopover = false) => {
  addFormFieldUid(field, keyName)
  let FieldComponent = null
  switch (field.type) {
    case fieldsTypes.singleLineText:
      FieldComponent = <SinglelineText field={field} fieldWidth={fieldWidth} mode={mode} />
      break;
    case fieldsTypes.number:
      FieldComponent = <Number field={field} fieldWidth={fieldWidth} mode={mode} />
      break;
    case fieldsTypes.multiLineText:
      FieldComponent = <MultilineText field={field} fieldWidth={fieldWidth} mode={mode} />
      break;
    case fieldsTypes.group:
      FieldComponent = <Group field={field} boundaryRef={boundaryRef} mode={mode} />
      break;
    case fieldsTypes.tags:
      FieldComponent = <Tags field={field} fieldWidth={fieldWidth} mode={mode} />
      break;
    case fieldsTypes.permanentUrl:
      FieldComponent = <PermanentUrl field={field} fieldWidth={fieldWidth} mode={mode} />
      break;
    case fieldsTypes.select:
      FieldComponent = <SelectField field={field} mode={mode} inGroupPopover={inGroupPopover} />
      break;
    case fieldsTypes.radio:
      FieldComponent = <RadioField field={field} mode={mode} />
      break;
    case fieldsTypes.checkbox:
      FieldComponent = <CheckboxField field={field} mode={mode} />
      break;
    default:
      return null;
  }
  return <div data-test-id={`cs-asset-details-field-${field.formFieldUid}-main-wrapper`}>
    <Field>
      {field.type !== fieldsTypes.group ? getFieldLabelDOM(field) : null}
      {FieldComponent}
      {getFieldInstructionTextDOM(field)}
    </Field>
  </div>
}

export const getFieldValidationErrorMessageDOM = (meta: any, index?: any, errorMessage?: any, testId?: any) => {
  // if (!meta.touched) {
  //   return null;
  // }
  if (meta?.error && typeof index !== 'number' && (errorMessage || meta.error)) {
    return (
      <div>
        <ValidationMessage testId={testId} version="v2">
          {errorMessage || (meta.error ? meta.error : '')}
        </ValidationMessage>
      </div>
    );
  } else if (typeof index === 'number' && meta?.error?.[index]) {
    return (
      <div>
        <ValidationMessage testId={testId} version="v2">
          {meta?.error?.[index] ? meta?.error?.[index] : ''}
        </ValidationMessage>
      </div>
    );
  }
  return null;
};

const MaximumInstanceModal = (props) => {
  return (
    <div>
      <ModalHeader title={"Maximum Instance Limit Reached"} closeModal={props.closeModal} />
      <ModalBody className="modalBodyCustomClass">
        <div className='maximum-instance-modal-body'>You have reached the maximum number of instances</div>
      </ModalBody>
      <ModalFooter>
        <ButtonGroup>
          <Button version='v2' onClick={props.closeModal} buttonType="tertiary" testId={"asset-modal-reset"}>
            Okay
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </div>
  )
}

export const AddInstanceButton = (props: any) => {
  const { field, push, valueLength } = props
  const onAddInstance = () => {
    if ((isUndefined(valueLength)) || (valueLength < field.maxInstances)) {
      push('')
    } else {
      cbModal({
        component: props => <MaximumInstanceModal {...props} />,
        modalProps: {
          size: 'small',
          customClass: 'asset-details-v2-fields-container__maximum-instance-modal-body',
        },
      })
    }
  }
  return <Button version='v2' size='small' onClick={onAddInstance} buttonType='tertiary' icon='Plus' iconPosition='left' testId={`cs-asset-details-field-${field?.formFieldUid}-add-instance-button`}>Add an instance</Button>
}

export const DeleteDom = ({ iconTestId, labelTestId, labelText }) => {
  return (
    <div className='flex-v-center'>
      <Icon testId={`${iconTestId}`} className='mr-8' icon="Delete" size="medium" version='v2' />
      <Paragraph testId={`${labelTestId}`} tagName='p' text={labelText} variant='p2' />
    </div>
  )
}

export const ContextualDropdown = ({ contextualDropdownActionArray, field }) => {
  return (
    <div className={`field-contextual-dropdown ${field?.showCharacterCount ? 'ml-4' : 'ml-10'}`} data-test-id={`cs-asset-details-field-${field?.formFieldUid}-contextual-dropdown-wrapper`}>
      <Dropdown className='action-dropdown' version='v2'
        list={
          contextualDropdownActionArray
        } type='click' withIcon={true} closeAfterSelect={true} dropDownPosition="left" testId={`cs-asset-details-field-${field?.formFieldUid}-contextual-dropdown`}>
        <Tooltip content={`More Actions`} position="top" showArrow={false}
          // className='font-size-small' 
          testId={`cs-asset-details-field-${field?.formFieldUid}-contextual-dropdown-tooltip`} variantType='dark'
          type="secondary">
          <Button testId={`cs-asset-details-field-${field?.formFieldUid}-contextual-dropdown-icon`} tabIndex={0} onlyIcon={true} iconProps={{ size: 'small' }} onlyIconHoverColor="primary" version="v2" icon="v2-DotsThreeLargeVertical" />
        </Tooltip>
      </Dropdown>
    </div>
  )
}

export const contextualDropdownActionArray = (field, index, remove) => [
  {
    label: (
      <DeleteDom iconTestId={`cs-asset-details-field-${field?.formFieldUid}-contextual-dropdown-delete-icon`} labelTestId={`cs-asset-details-field-${field.formFieldUid}-contextual-dropdown-delete-label`} labelText={'Delete Instance'} />
    ),
    id: 'delete',
    className: 'action-delete-instance',
    // className: 'delete-block',
    action: (e): void => {
      remove(index)
    },
    testId: `cs-asset-details-field-${field?.formFieldUid}-contextual-dropdown-delete-icon`,
    disable: field?.value?.length <= 1
  }
]

export const getTextFieldPlaceholderText = (field: any) => {
  return field?.placeholder_text || 'Type something...';
};
export const isFieldMultiple = (field: any) => {
  return field.multiple;
};

export const isFieldMandatory = (field: any) => {
  return field.required;
};

export const shouldShowInstruction = (field: any) => {
  return field?.instructionText;
};

export const shouldShowHelpText = (field: any) => {
  return field?.helperText;
};

export const getFieldDefaultValue = (field: any) => {
  return field?.default_value;
};

export const getFieldMaxInstance = (field: any) => {
  return field?.maxInstances;
};

export const isGroupField = (field: any) => {
  return field.display_type === 'GROUP';
};

export const getFieldInstructionText = (field: any) => {
  return field?.instructionText;
};

export const getFieldHelpText = (field: any) => {
  return field?.helperText;
};

export const isFieldUnique = (field: any) => {
  return field.unique;
};

export const getValidationErrorMessage = (field: any) => {
  return field?.validation_error_message;
};

export const getFieldRegexPattern = (field: any) => {
  return field?.format;
};

export const getTextFieldMinLength = (field: any) => {
  return field?.min;
};

export const getTextFieldMaxLength = (field: any) => {
  return field?.max;
};

export const getNumberFieldMinValue = (field: any) => {
  return field?.min;
};

export const getNumberFieldMaxValue = (field: any) => {
  return field?.max;
};

export const getGroupFieldChildCount = (field: any) => {
  return field.child.length;
};

export const getFieldHelpTextDOM = (field: any) => {
  if (shouldShowHelpText(field)) {
    return (
      <Tooltip variantType='dark'
        type="secondary" content={getFieldHelpText(field)} position="top"
        // className='font-size-small' 
        testId={`cs-asset-details-field-${field?.formFieldUid}-help-text-tooltip`}>
        <Icon icon="Question" version="v2" size="small" testId={`cs-asset-details-field-${field?.formFieldUid}-help-text-icon`} />
      </Tooltip>
    );
  } else {
    return null;
  }
};

export const getFieldTitle = (field: any) => {
  if (!field?.title) {
    return null;
  }
  return (
    <div data-test-id={`cs-asset-details-field-${field?.formFieldUid}-label`}>
      {field.title}
    </div>
  );
};

export const getFieldLabelDOM = (field: any) => {
  const { name } = field;
  const isMandatory = isFieldMandatory(field);
  const isGroup = isGroupField(field);
  // Inline select variants (RADIO/CHECKBOX) show a live "{N} selected" count badge
  // in the label row (Figma). The dropdown SELECT variant indicates selection via
  // its chips instead, so it is intentionally excluded here.
  const isInlineSelect =
    field?.type === fieldsTypes.radio || field?.type === fieldsTypes.checkbox;

  const fieldTitle = getFieldTitle(field);
  if (!fieldTitle) {
    return null;
  }

  return (
    <FieldLabel
      className={`${isGroup ? 'group-field-label' : ''}`}
      version="v2"
      required={isMandatory}
      htmlFor={name}
      helpText={getFieldHelpTextDOM(field)}
      testId={`cs-asset-details-field-label-${field?.formFieldUid}`}
    >
      {isInlineSelect ? (
        <span className="sf-label-with-count">
          {fieldTitle}
          <SelectSelectedCount
            formFieldUid={field?.formFieldUid}
            multiple={field?.type === fieldsTypes.checkbox}
          />
        </span>
      ) : (
        fieldTitle
      )}
    </FieldLabel>
  );
};

export const getFieldInstructionTextDOM = (field: any) => {
  if (shouldShowInstruction(field)) {
    return <InstructionText testId={`cs-asset-details-field-instruction-text-${field?.formFieldUid}`}>{getFieldInstructionText(field)}</InstructionText>;
  } else {
    return null;
  }
};

export const ReadOnlyField = ({ width, showCopyIcon, value, copyLabel, copyIconSize, testId, copyContent }: any) => {
  const [isCopied, setCopied] = React.useState(false);
  const text = copyContent || value;
  const handleCopy = (e) => {
    e.stopPropagation()
    e.preventDefault()
    const copyText = text
    navigator.clipboard.writeText(copyText).then(() => {
      setCopied(true)
    }).catch((err) => {
    });
  }

  const handleReset = () => {
    setCopied(false);
  };
  return (
    <div data-test-id={`cs-asset-details-field-${testId}-read-only-text-wrapper`} className={`TextInput__only-label ${showCopyIcon ? 'TextInput__only-label-copy-option' : ''}`}>
      <div className={`TextInput__only-label-content TextInput--${width}`} data-test-id={`cs-asset-details-field-${testId}-read-only-text`}> {value ? value : '-'}</div>
      {showCopyIcon && (
        <div className='TextClipBoard' data-test-id={`cs-asset-details-field-${testId}-copy-icon-wrapper`} >
          <Tooltip
            content={!isCopied ? `Copy ${copyLabel}` : 'Copied'}
            variantType='dark'
            type="secondary"
            position="top"
            trigger={isCopied ? 'mouseenter focusin' : 'mouseenter click focusin'}
            onHidden={handleReset}
            // className='font-size-small'
            testId={`cs-asset-details-field-${testId}-copy-icon-tooltip`}
          >
            <span tabIndex={0} aria-label={!isCopied ? `Copy ${copyLabel}` : 'Copied'} className='clipboard-copy' onClick={handleCopy} onKeyDown={(e: any) => {
              if (isEnterPressed(e.key)) {
                e.preventDefault();
                e.stopPropagation();
                e.target.click();
              }
            }}>
              <Button version="v2" buttonType="tertiary" size={copyIconSize} className='TextClipBoard__icon' testId={`cs-asset-details-field-${testId}-copy-icon`} icon="v2-Copy" onlyIcon={true} onlyIconHoverColor="secondary" />
            </span>
          </Tooltip>
        </div>
      )}
    </div>
  )
}

export const SuggestWithAi = ({ field, AiSuggestionComponent, updateValue, boundaryRef, unavailable, unavailableMessage }) => {
  const [toggleShow, setToggleShow] = useState(false)
  const popoverButtonRef = useRef(null)
  const onPopoverCloseHandler = () => {
    setToggleShow(false)
  }
  const onPopoverOpenHandler = () => {
    setToggleShow(true)
  }

  if (unavailable) {
    return (
      <div className="SuggestWithAi SuggestWithAi__unavailable" data-test-id={`cs-asset-details-field-${field?.formFieldUid}-suggest-with-ai-unavailable`}>
        <Icon icon="Warning" version="v2" size="medium" className="SuggestWithAi__unavailable-icon" />
        <span className="SuggestWithAi__unavailable-text">{unavailableMessage}</span>
      </div>
    )
  }

  return <div className="SuggestWithAi" data-test-id={`cs-asset-details-field-${field?.formFieldUid}-suggest-with-ai-wrapper`}>
    <Button size='small' buttonRef={popoverButtonRef} onClick={onPopoverOpenHandler} buttonType='tertiary' icon='v2-AIAssist2' iconPosition='left' version='v2' testId={`cs-asset-details-field-${field?.formFieldUid}-suggest-with-ai-button`}>Suggest {field?.title} with AI</Button>
    <Popover
      isOpen={toggleShow}
      onClose={onPopoverCloseHandler}
      anchorRef={popoverButtonRef}
      boundaryRef={boundaryRef}
      popoverWidth={400}
      testId={`cs-asset-details-field-${field?.formFieldUid}-suggest-with-ai-popover`}
    >
      <div data-test-id={`cs-asset-details-field-${field?.formFieldUid}-suggest-with-ai-popover-content`}>
        <AiSuggestionComponent updateValue={updateValue} closePopover={onPopoverCloseHandler} />
      </div>
    </Popover>
  </div>
}